<template>
  <div>
    <CRow>
      <CCol md="12">
          <CCardHeader class="p-1">
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                <strong>{{$t('documentDoc')}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="doc_detail.isFinal==0" @click="finalize()" size="sm"
                         color="secondary"
                         class="mr-1">
                  {{$t('save')}}
                </CButton>
                <CButton v-if="doc_detail.isFinal==0" @click="delete_item_dialog()" size="sm"
                         color="secondary"
                         class="mr-1">
                  {{$t('buttons.delete')}}
                </CButton>

                <CButton
                    v-if="doc_detail.isFinal!=0"
                    @click="return_item_dialog()" size="sm"
                         color="secondary"
                         class="mr-1">

                  {{ $t('buttons.returnDocument') }}
                </CButton>

                <CButton @click="print()" size="sm"
                         color="secondary"
                         class="mr-1">

                  {{ $t('buttons.print') }}
                </CButton>

              </CCol>
            </CRow>
          </CCardHeader>

          <CCard id="printMe">
            <CCardHeader>
              <CRow>

                <CCol  style="text-align: right">
                  <strong>{{$t('docNumber')}} : {{ doc_detail.docMasterCode }}</strong>
                </CCol>
                <CCol  style="text-align: right">
                  <strong>{{$t('referenceNo')}} : {{ doc_detail.refrenceCode }}</strong>

                </CCol>
                <CCol  style="text-align: center">

                  <strong>{{ $t('components.date') }} : {{ get_date( doc_detail.docDate) }}</strong>

                </CCol>

                <CCol  style="text-align: left">
                  <strong>{{$t('documentType')}} : {{ doc_detail.docTypeTitle }}</strong>

                </CCol>
              </CRow>

            </CCardHeader>
            <CCardBody>

              <CRow>

                <CCol sm="4" md="4">
                  <strong>{{$t('tables.summary')}}: {{ doc_detail.summary }}</strong>
                </CCol>
              </CRow>

              <CDataTable
                  :items="doc_detail.details"
                  :fields="fields"
                  striped
                  border
                  :items-per-page="200"
                  hover
                  pagination
              >
                <template #row="{item,index}">

                  <td>
                    <strong >{{ index + 1 }}</strong>
                  </td>

                </template>

                <template #debtor="{item}">

                  <td>
                    <strong style="float: right" >{{ get_currency(Math.abs(item.debtor)) }}</strong>
                  </td>
                </template>


                <template #accountName="{item}">

                  <td v-if="!item.debtor" class="text-end">
                    <strong >{{ item.accountCode }} {{ item.accountName }}</strong>
                  </td>
                  <td v-else>
                    <strong >{{ item.accountCode }} {{ item.accountName }}</strong>
                  </td>
                </template>
                <template #tafsiliTitle="{item}">

                  <td v-if="!item.debtor" class="text-end">
                    <strong ><br v-if="index==doc_detail.details.length-1">{{ item.tafsiliTitle }}</strong>
                  </td>
                  <td v-else>
                    <strong ><br v-if="index==doc_detail.details.length-1">{{ item.tafsiliTitle }}</strong>
                  </td>
                </template>
                <template #joz="{item,index}">

                  <td v-if="index!=doc_detail.details.length-1">
                    <br>
                    <strong v-if="item.debtor"  style="float: right" >{{ get_currency(Math.abs(item.debtor)) }}</strong>
                    <strong v-else  style="float: right" >{{ get_currency(Math.abs(item.creditor)) }}</strong>
                  </td>
                  <td v-else>
                 </td>
                </template>

                <template #creditor="{item}">

                  <td>
                    <strong style="float: right" >{{ get_currency(Math.abs(item.creditor)) }}</strong>

                  </td>

                </template>



              </CDataTable>


            </CCardBody>
          </CCard>

      </CCol>
    </CRow>
    <CModal
        :title="$t('requestDetail')"
        color="dark"
        size="lg"
        :show.sync="pre_finalize"
    >
      <CRow>
        <CCol col="4"><label>{{$t('docNumber')}}: 1</label></CCol>
        <CCol col="4"><label>{{$t('documentDoc')}}</label></CCol>
        <CCol col="4"><label>{{$t('docDate')}}</label></CCol>
      </CRow>
      <CRow>
        <CCol col="4"><label>{{$t('docDescription')}}:</label></CCol>
        <CCol col="4"><label></label></CCol>
        <CCol col="4"><label>Page 1</label></CCol>
      </CRow>
      <CDataTable
          :items="pre_finalize_items"
          :fields="pre_finalize_fields"
          striped
          border
          :items-per-page="200"
          hover
          pagination
      >

        <template #under-table>
          <label></label>
          <br>
          <label>{{$t('tanzimKonande')}}</label>
        </template>
      </CDataTable>

      <template #footer>
        <CButton @click="pre_finalize = false,finalize()" color="danger">{{$t('buttons.ok')}}</CButton>
        <CButton @click="pre_finalize = false" color="danger">{{$t('buttons.cancel')}}</CButton>
      </template>
    </CModal>
    <CModal
        :title="$t('warning')"
        color="dark"
        size="md"
        :show.sync="return_document_modal"
    >
      <CRow>
        <CCol col="12"><label>{{$t('sureToReturnDocument')}}</label></CCol>


       <CCol col="12">
         <date-picker
           :label="$t('date')"
v-model="return_doc_date" />
       </CCol>
       <CCol col="12">
         <CInput :label="$t('tables.summary')"
                 v-model="return_doc_summary"
                 />
       </CCol>
      </CRow>

      <template #footer>
        <CButton @click="return_document_modal = false,return_item()" color="danger">{{$t('buttons.ok')}}</CButton>
        <CButton @click="return_document_modal = false" color="danger">{{$t('buttons.cancel')}}</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes',
  ],
  styles: [
    'https://cdn.rtlcss.com/bootstrap/v4.2.1/css/bootstrap.min.css',
    'https://omdesho.ir/print_css/printing.css',

  ]
}

Vue.use(VueHtmlToPaper, options);
var items_data = [];


export default {
  name: 'Login',
  data() {
    return {
      return_document_modal:false,
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      VUE_APP_Currency: localStorage.getItem('currency'),
      VUE_APP_NAME: localStorage.getItem('app_name'),
      date: '',
      pre_finalize:false,
      doc_id :'',
      product_items: items_data.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:3%;padding:0px'},
        {key: 'accountName', label: this.$t('accountSarfasl'), _style: 'width:20%;padding:0px'},

        {key: 'tafsiliTitle', label: this.$t('tafsiliAccount'), _style: 'width:20%;padding:0px'},

        {key: 'debtor', label: this.$t('bedehkar'), _style: 'width:10%;padding:0px'},
        {key: 'creditor', label: this.$t('bestankar'), _style: 'width:10%;padding:0px'},

      ],


      pre_finalize_items: [{
        tafzili:"9",
        moein:"8",
        kol:"12",
        account:"پرداخت هزینه سوخت",
        price_joz:"120000",

        price_bedehkar:"1000",
        price_bestankar:"1000"},{
        tafzili:"",
        moein:"",
        kol:"",
        account:"",
        price_joz:this.$t('totalDoc'),
        price_bedehkar:"1000",
        price_bestankar:"1000"}],
      pre_finalize_fields: [
        {key: 'tafzili', label: this.$t('tafsili'), _style: 'width:3%;padding:0px'},
        {key: 'moein', label: this.$t('moein'), _style: 'width:3%;padding:0px'},
        {key: 'kol', label: this.$t('total'), _style: 'width:3%;padding:0px'},
        {key: 'account', label:this.$t('components.groupName'), _style: 'width:10%;padding:0px'},
        // {key: 'unit', label: this.$t('tables.unit'), _style: 'padding:0px'},
        {key: 'price_joz', label: this.$t('subAmount'), _style: 'width:5%;padding:0px'},
        {key: 'price_bedehkar', label: this.$t('bedehkar'), _style: 'width:5%;padding:0px'},
        {key: 'price_bestankar', label:this.$t('bestankar'), _style: 'width:5%;padding:0px'},

      ],
      fields_total_price: [
        {key: 'resultTitle', label: this.$t('tables.name'), _style: 'padding:5px;display:none'},
        {key: 'resultPrice', label: this.$t('tables.price'), _style: 'padding:5px;display:none'},

      ],

      selectedTypeQty: 1,
      selectedTypeLabel: this.$t('components.seller'),
      selectedTypeLabelRevert: this.$t('buttons.buyer'),
      selectedTypeTitle: this.$t('components.documentBuy'),
      selectedType: 1,
      tablo: '',
      address: '',

      vMobile: '',
      partyMobile: '',
      tozikonandeMobile: '',

      document_person: '',
      document_person_id: '',
      document_summary: '',
      document_visitor: '',
      document_driver: '',
      doc_detail: {},


      product_name: '',
      product_count: '',
      product_unit: '',
      product_summary: '',
      product_price: '',

      unit_items: [],
      doc_status: 0,
      // total_price: 0,
      details: [],
      permission_group_items: [],
      selected_permission_group: 0,

      places_items: [],
      unit_items_filtered: [],
      selected_place: '',
      selected_product: null,
      return_doc_date: '',
      return_doc_summary: '',
      status_form: 0,
      master_id: 0,
      document_result_price: [],

    }
  }, mounted() {
this.doc_id = this.$route.params.doc_id;
    this.$root.root_validate_errors = [];

    // this.get_product_units();
    this.get_document_master();
this.return_doc_date = this.get_today()

    bus.$on('delete_confirm_factor'+this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
    bus.$on('return_confirm_factor'+this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.return_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  created() {

  },
  watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    },

    'selectedType': function () {
      if (this.selectedType == 1) {

        this.selectedTypeLabel = this.$t('components.seller');
        this.selectedTypeLabelRevert = this.$t('components.buyer');
        this.selectedTypeQty = 1;
        this.selectedTypeTitle = this.$t('components.documentBuy');
      }
      if (this.selectedType == 3) {
        this.selectedTypeLabel = this.$t('components.buyer');
        this.selectedTypeLabelRevert = this.$t('components.seller');
        this.selectedTypeQty = -1;
        this.selectedTypeTitle = this.$t('components.documentSell');

      }
      if (this.selectedType == 5) {
        this.selectedTypeLabel = this.$t('components.employee');
        this.selectedTypeLabelRevert = this.$t('components.company');
        this.selectedTypeQty = 1;
        this.selectedTypeTitle = this.$t('components.documentFirst');

      }
    },
  },
  methods: {
    finalize() {
      var self = this;


      const formData = new FormData();

      var url = "AddAccountDocFinal";

      formData.append("id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          self.get_document_master();

        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_product_units() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetProductUnits', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.unit_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    print() {
      // Pass the element id here
      this.$htmlToPaper('printMe');
    },
    goEdit() {
      // Pass the element id here
      this.$router.push({path: "/dashboard/documents/edit-document/" + this.doc_id});
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    get_document_master() {
      var self = this;

      const formData = new FormData();

      var url = "GetAccountDocByDocId";

      formData.append("id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
//     self.items_buy = content_data.data.map((item, row_id) => {
// // if(item.isCustomer){
//     return {...item, row_id}
          self.doc_detail = response.data.data
          var total_debtor = 0;
          var total_creditor = 0;
          self.doc_detail.details.forEach((val) => {
            total_debtor+=val.debtor;
            total_creditor+=val.creditor;

              });
          self.doc_detail.details.push({accountName:'',tafsiliTitle:self.$t('totalDoc'),debtor:total_debtor,creditor:total_creditor,});

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_document_details() {
      var self = this;


      const formData = new FormData();

      var url = "GetDocItemsByDocId";

      formData.append("id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.product_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}

          });


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog() {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], 'delete_confirm_factor'+this.confirm_delete_name);

      // this.status_form = this.masterFactorId;

    },
    return_item_dialog() {
      // this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("sureToReturnDocument"), [this.$t("dialogs.ok")], 'return_confirm_factor'+this.confirm_delete_name);
this.return_document_modal = true
      // this.status_form = this.masterFactorId;

    },
    get_user_data() {

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetPersonById";

      formData.append('id', this.document_person_id);


      axios.post(url, formData, {}).then((res) => {

        var person  = res.data.data.person;
        self.document_person = person.personName +" "+ person.surName +" "+ person.mobileNo
        // self.document_person_remain_amount = res.data.data.mande;
        var tota_price = self.document_result_price[self.document_result_price.length-1].resultPrice;
        tota_price = tota_price.replaceAll(",","");

        // var  obj = {resultTitle: "مانده از قبل", resultPrice: res.data.data.mande.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")};
      tota_price =   parseInt(res.data.data.mande)+parseInt(tota_price)

        // self.document_result_price.push(obj)
        // obj = {resultTitle: "مبلغ نهایی", resultPrice:tota_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") };
        // self.document_result_price.push(obj)


      })
          .catch(function (error) {

            console.log(error);
          });


    },

    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteAccountDoc";


      formData.append('id', this.doc_id);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
if(res.data.statusCode==0){
  self.status_form = 0;

  // self.get_lists();
  self.$router.push({ path: '/dashboard/accounting/add-accounting-doc'});
  // self.$router.go(-1)

}

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    return_item() {
      let self = this;
      const formData = new FormData();
      let url = "AddAccountDoc";
      // doc_detail.details
      let temp_detail = JSON.parse(JSON.stringify(this.doc_detail.details))
      temp_detail = temp_detail.reverse()
      var details = [];
      var validate = true;
      temp_detail.forEach(function (val,index){
        if(index>0){
          var obj = {
            DocType: 7,
            // DocName: self.doc_detail.docTypeTitle,
            ReferenceId: self.doc_detail.id,
            ReferenceType: 6,
            DocDate: self.return_doc_date,
            Summary: self.return_doc_summary + " - "+self.$t('returnOperation')+" "+self.doc_detail.docMasterCode,
            AccountId: val.accountId,
            TafsiliId: val.tafsiliId,
            // TafsiliTitle: val.tafsiliTitle,

          };
          if(val.creditor!=0){
            obj.Debtor= val.creditor
          }
          if(val.debtor!=0){
            obj.Creditor= val.debtor
          }
          if (obj.ReferenceId == null) {
            obj.ReferenceId = 0;
          }
          if (obj.TafsiliId == null || obj.TafsiliId == 0 || obj.TafsiliId == '') {
            validate = false;
          }
          if ((obj.Debtor == null || obj.Debtor == 0 || obj.Debtor == '') && (obj.Creditor == null || obj.Creditor == 0 || obj.Creditor == '')) {
            validate = false;
          }
          details.push(obj)
        }

      })

      if (validate == false) {
        console.log("validate",details)
        this.$root.modal_component.show_validate_errors([this.$t('fillAllFields')])
        return false;
      }
      formData.append('input', JSON.stringify(details));

      axios.post(url, formData, {}).then((res) => {
        //

        self.$root.modal_component.show_api_response_modals(res);

        // self.get_lists();
        if (res.data.statusCode == 0) {

          // self.$router.push({path: "/dashboard/accounting/show-accounting-doc/" + res.data.data.id})
window.open("/dashboard/accounting/show-accounting-doc/" + res.data.data.id)
        }


      })
          .catch(function (error) {

            console.log(error);
          });


    }

  }
}

</script>
